import {ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation} from '@angular/core';
import {RoutesEnums} from '../../../enums/RoutesEnums';
import {UrlTermsSymbolsEnum} from '../../../enums/SeoEnums';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {ToolsService} from '../../../services/tools.service';
import {DLPageTypeEnum} from '../../../enums/DataLayerEnums';
import {WPPostSymptomPage} from '../../../modules/search/modules/search-content-pages-v2/typings/WPPostSymptomPage';

@Component({
  selector: 'app-symptom-page-puff',
  templateUrl: './symptom-page-puff.component.html',
  styleUrls: ['./symptom-page-puff.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SymptomPagePuffComponent {
  puffDataMultitype = input<any>(null);
  puffData = input<WPPostSymptomPage>(null);
  index = input<number>(null);
  numberOfPriorityPuffs = input<number>(1);
  qaHookPrefix = input<string>(null);
  pageType = input<DLPageTypeEnum>(null);
  forceContentCssClass = input<string>(null);

  public contentCssClass = computed<string>(() =>
    this.forceContentCssClass() ? this.forceContentCssClass() : 'py-6 px-4 md:px-0',
  );
  public puffDataToUse = computed<WPPostSymptomPage>(() => {
    return this.puffDataMultitype() ? (this.puffDataMultitype() as WPPostSymptomPage) : this.puffData();
  });
  public hasImage = computed<boolean>(() => {
    return (
      this.puffDataToUse() &&
      (this.puffDataToUse().featured_media > 0 || this.puffDataToUse().acf.backgroundImageMobile != null)
    );
  });
  public routePath = computed<string[]>(() => {
    return ['/', RoutesEnums.SEARCH, `${this.puffDataToUse().slug}-${UrlTermsSymbolsEnum.SYMPTOM}`];
  });
  private tools = inject(ToolsService);
  private urlBuilder = inject(UrlBuilderService);
  private cssPrefix = computed<string>(() => {
    return !this.tools.isNil(this.qaHookPrefix()) ? this.qaHookPrefix() : 'test-page-puff';
  });
  public titleCssClass = computed<string>(() => {
    return !this.tools.isNil(this.index()) ? `${this.cssPrefix()}-title-${this.index()}` : `${this.cssPrefix()}-title`;
  });
  public btnCssClass = computed<string>(() => {
    return !this.tools.isNil(this.index())
      ? `${this.cssPrefix()}-morebtn-${this.index()}`
      : `${this.cssPrefix()}-morebtn`;
  });
}
